/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor } from './IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor';
import {
    IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorFromJSON,
    IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorFromJSONTyped,
    IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorToJSON,
    IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorToJSONTyped,
} from './IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor';

/**
 * 
 * @export
 * @interface IntegrationEventPccPatientLeadsInnerInsurancesInner
 */
export interface IntegrationEventPccPatientLeadsInnerInsurancesInner {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    lead_id?: string;
    /**
     * 
     */
    payor_id?: string;
    /**
     * 
     */
    unmatched_payor_name?: string;
    /**
     * 
     */
    type?: string;
    /**
     * 
     */
    coverage_priority?: string;
    /**
     * 
     */
    is_active_payer?: boolean;
    /**
     * 
     */
    payor?: IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor;
}

/**
 * Check if a given object implements the IntegrationEventPccPatientLeadsInnerInsurancesInner interface.
 */
export function instanceOfIntegrationEventPccPatientLeadsInnerInsurancesInner(value: object): value is IntegrationEventPccPatientLeadsInnerInsurancesInner {
    return true;
}

export function IntegrationEventPccPatientLeadsInnerInsurancesInnerFromJSON(json: any): IntegrationEventPccPatientLeadsInnerInsurancesInner {
    return IntegrationEventPccPatientLeadsInnerInsurancesInnerFromJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerInsurancesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventPccPatientLeadsInnerInsurancesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'payor_id': json['payor_id'] == null ? undefined : json['payor_id'],
        'unmatched_payor_name': json['unmatched_payor_name'] == null ? undefined : json['unmatched_payor_name'],
        'type': json['type'] == null ? undefined : json['type'],
        'coverage_priority': json['coverage_priority'] == null ? undefined : json['coverage_priority'],
        'is_active_payer': json['is_active_payer'] == null ? undefined : json['is_active_payer'],
        'payor': json['payor'] == null ? undefined : IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorFromJSON(json['payor']),
    };
}

export function IntegrationEventPccPatientLeadsInnerInsurancesInnerToJSON(json: any): IntegrationEventPccPatientLeadsInnerInsurancesInner {
    return IntegrationEventPccPatientLeadsInnerInsurancesInnerToJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerInsurancesInnerToJSONTyped(value?: IntegrationEventPccPatientLeadsInnerInsurancesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'payor_id': value['payor_id'],
        'unmatched_payor_name': value['unmatched_payor_name'],
        'type': value['type'],
        'coverage_priority': value['coverage_priority'],
        'is_active_payer': value['is_active_payer'],
        'payor': IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorToJSON(value['payor']),
    };
}

